var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeggings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.096 22.149c.028-.029.028-.085.056-.112.084-1.512.14-2.969.084-3.864 0 0 .924-3.109 1.4-4.845-.336-.504-.784-1.148-1.289-1.875a63.562 63.562 0 00-2.128-2.856c-.112-.14-.196-.252-.28-.364.14 1.344.28 3.611.028 5.18-.391 2.38-.196 4.004-.196 4.004s-.671 2.296-.335 4.871l.391 3.136c.029 0 .056-.028.056-.028.14-.056.252-.056.364-.085.364-.055.672-.14 1.176-1.26.168-.42.421-1.12.673-1.902z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.04 15.371c.14-2.324-3.92-8.371-4.256-9.155-.335-.785 1.149-2.072 1.149-2.072-1.289-3.388-3.977-2.688-3.977-2.688-.84.364-1.429.895-1.876 1.4a4.574 4.574 0 00-1.036 2.911c0 1.456.84 1.764 3.5 5.544 3.276 4.676 2.829 4.565 2.829 4.565-1.848 2.071-2.996 6.72-3.724 8.288-.252.589-.476.924-.7 1.092.308.42.895.951 2.015 1.344 1.485-3.304 4.789-8.764 4.789-8.764 1.427-1.736 1.287-2.464 1.287-2.464z",
    fill: "#000"
  })));
}

export default SvgLeggings;